
export class Silder {
    slug: string;
    title: string;
    subtitle: string;
    link: string;
    imagemDestaque: string;
  }
